<template>
    <SideFormSection>
        <template #title> In Person Locations </template>
        <template #rawContent>
            <Card
                title="In Person Locations"
                iconName="location-dot"
            >
                <template #content>
                    <div class="space-y-4">
                        <InPersonHostDefinedMeetingLocationTable
                            :inPersonHostDefinedMeetingLocations="
                                localInPersonHostDefinedMeetingLocations
                            "
                            @onInPersonHostDefinedMeetingLocationsUpdated="
                                handleInPersonHostDefinedMeetingLocationsUpdated(
                                    $event.inPersonHostDefinedMeetingLocations,
                                )
                            "
                        />
                    </div>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import InPersonHostDefinedMeetingLocation from '@/App/Company/Entity/InPersonHostDefinedMeetingLocation'
    import InPersonHostDefinedMeetingLocationTable from '@/App/Company/Component/InPersonHostDefineMeetingLocation/InPersonHostDefinedMeetingLocationTable.vue'

    const props = defineProps({
        inPersonHostDefinedMeetingLocations: {
            type: Array as PropType<InPersonHostDefinedMeetingLocation[]>,
            required: true,
        },
    })

    const localInPersonHostDefinedMeetingLocations = ref<
        InPersonHostDefinedMeetingLocation[]
    >(props.inPersonHostDefinedMeetingLocations)

    const handleInPersonHostDefinedMeetingLocationsUpdated = (
        inPersonHostDefinedMeetingLocations: InPersonHostDefinedMeetingLocation[],
    ): void => {
        localInPersonHostDefinedMeetingLocations.value =
            inPersonHostDefinedMeetingLocations
    }
</script>
